<template>
  <div>
  <div class="reason" v-if="list.reason">
      未通过原因：{{ list.reason }}
    </div>
  <div class="form-detail">
    <van-cell-group title="（一）基本信息" inset>
      <van-cell title="学校类型" :value="getLabel(schoolTypeList, list.schoolType)" />
      <van-cell title="学校（机构）标识码" :value="list.schoolCode" />
      <van-cell title="所处区域" :value="getLabel(schoolAreaList, list.location)" />
    </van-cell-group>

    <van-cell-group title="（二）少先队组织信息" inset>
      <van-cell title="中队数量" :value="list.squadronNum + '个'" />
      <van-cell title="少先队员人数" :value="list.youngPioneersNum + '人'" />
      <van-cell :title="getStudentNumLabel(list.schoolType)" :value="list.studentNum + '人'" />
      <van-cell title="最近一次少代会召开时间" :value="list.congressType == 2 ? '未开过' : format(list.lastCongressTime, 6)" />
      <van-cell v-if="list.schoolType != 2 && list.schoolType != 5" title="学校学生分几批次入队" :value="getLabel(ruduiPiciList, list.batchEntry)" />

      <van-cell title="学校是否开展“红领巾奖章”争章活动" :value="list.hasRedScarfBadge == 1 ? '是' : '否'" />
      <van-cell title="学校是否开展“红领巾讲解员”活动" :value="list.hasRedScarfExplainer == 1 ? '是' : '否'" />
      <van-cell title="学校是否开展“少年军校”活动" :value="list.hasYoungMilitarySchool == 1 ? '是' : '否'" />

      <van-cell v-if="list.schoolType != 2 && list.schoolType != 5" title="学生入队时首次佩戴的红领巾是否由学校配发" :value="list.isRedScarfDistributed == 1 ? '是' : '否'" />
      <van-cell title="是否有少先队队室" :value="list.hasYoungPioneersRoom == 1 ?  getLabel(sxdClassMList, list.roomSize)  : '否'" />
      <van-cell title="是否有少先队鼓号队" :value="list.hasDrumBugleCorps == 1 ? getLabel(sxdGhdPopList, list.corpsSize) : '否'" />
      <van-cell title="少先队活动课课时安排情况" :value="getLabel(sxdHdkList, list.activityClassSchedule)" />
      <van-cell title="2025年度本校中队辅导员参加少先队线下相关培训的人数" :value="list.offlineTrainingNum + '人'" />
    </van-cell-group>

    <van-cell-group title="（三）学校少工委主任信息" inset>
      <van-cell title="学校少工委主任由谁来担任" :value="getLabel(sgwZhuRenList1, list.directorPosition)" />
      <template v-if="list.directorPosition < 6">
        <van-cell title="学校少工委主任姓名" :value="list.directorName" />
        <van-cell title="政治面貌" :value="getLabel(zzmmList02, list.directorPoliticalStatus)" />
        <van-cell title="手机号" :value="list.directorTel" />
      </template>
    </van-cell-group>

    <van-cell-group title="（四）大队辅导员信息" inset>
      <van-cell title="在本填报年度，负责学校少先队工作的人员身份类型" :value="getLabel(daDuiFdyTpyeList, list.personnelStatus)" />
      
      <template v-if="list.name">
        <van-cell title="姓名" :value="list.name" />
        <van-cell title="大队辅导员本人聘书或任命文件的图片">
          <template #value>
            <van-image
              height="100"
              width="100"
              fit="contain"
              :src="list.file"
              @click="previewImage(list.file)"
            />
          </template>
        </van-cell>
        <van-cell title="身份证号" :value="list.idCard" />
        <van-cell title="性别" :value="list.sex == 1 ? '男' : '女'" />
        <van-cell title="年龄" :value="list.birthday+'岁'" />
        <van-cell title="政治面貌" :value="getLabel(zzmmList02, list.politicalStatus)" />
        <van-cell title="手机号" :value="list.tel" />
        <van-cell title="是否有师范生" :value="list.isNormalStudent == 1 ? '是' : '否'" />
        <van-cell title="全日制教育学历" :value="getLabel(eduList01, list.fullTimeEdu)" />
        <van-cell title="所学专业大类" :value="getLabel(majorList, list.fullTimeMajor)" />
        <van-cell title="继续教育学历" :value="list.continueEdu == 0 ? '未参加' : getLabel(eduList01, list.continueEdu)" />
        <van-cell v-if="list.continueEdu != 0" title="所学专业大类" :value="getLabel(majorList, list.continueMajor)" />
      </template>

      <van-cell title="学校是否成立团组织" :value="list.hasLeagueOrg == 1 ? '是' : '否'" />
      <van-cell v-if="list.hasLeagueOrg == 1" title="是否兼任校内团干部职务" :value="list.isLeagueCadre == 1 ? '是' : '否'" />
      <van-cell v-if="list.isLeagueCadre == 1" title="兼任校内团干部职务" :value="getLabel(haveTuanJobMajorList, list.leaguePosition)" />

      <template v-if="list.startTime">
        <van-cell title="任本校大队辅导员开始时间" :value="format(list.startTime, 6)" />
        <van-cell title="累计从事少先队工作年限" :value="list.workYears + '年'" />
        <van-cell title="是否有担任中队辅导员经历" :value="list.hasSquadronExp == 1 ? '是' : '否'" />
        <van-cell v-if="list.hasSquadronExp == 1" title="担任中队辅导员累计年限" :value="list.squadronWorkYears + '年'" />
        <van-cell title="校内职务" :value="getLabel(schoolMajorList, list.schoolPosition)" />
        <van-cell v-if="list.treatmentRank" title="享受待遇" :value="getLabel(salaryList, list.treatmentRank)" />
        <van-cell title="职称" :value="getLabel(jobTitleList, list.professionalTitle)" />
        <van-cell title="任教学科门数" :value="getLabel(teachSubjectNumList, list.subjectNum)" />
        <van-cell title="任教学科" :value="getMultiLabel(teachSubjectsList, list.subjects)" />
        <van-cell title="每周课时数" :value="list.weeklyHours" />
      </template>

      <van-cell title="本校除正式大队辅导员以外，副大队辅导员人数" :value="list.deputyCounselorNum+'人'" />
    </van-cell-group>

    <van-cell-group title="填表人信息" inset>
      <van-cell title="填表人姓名" :value="list.fillerName" />
      <van-cell title="填表人手机号" :value="list.fillerTel" />
      <van-cell title="填表人工作单位及职务" :value="list.fillerUnitJob" />
    </van-cell-group>
  </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import {
  schoolTypeList,
  schoolAreaList,
  ruduiPiciList,
  sxdClassMList,
  sxdGhdPopList,
  sxdHdkList,
  sgwZhuRenList1,
  zzmmList02,
  eduList01,
  majorList,
  haveTuanJobMajorList,
  schoolMajorList,
  salaryList,
  jobTitleList,
  teachSubjectNumList,
  teachSubjectsList,
  daDuiFdyTpyeList
} from "@/common/js/field";
import { format } from "@/common/js/utils";

export default {
  name: "Form12Detail",
  props: {
    list: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const getLabel = (fieldList, key) => {
      if (key === null || key === undefined || key === "") return "-";
      const item = fieldList.find((i) => i.key == key);
      return item ? item.value : key;
    };

    const getStudentNumLabel = (schoolType) => {
      if (schoolType === 1) return "本校1-6年级学生数";
      if ([2, 5].includes(schoolType)) return "本校7-9年级学生数";
      if ([3, 4].includes(schoolType)) return "本校1-9年级学生数";
      return "本校学生数";
    };

    const getMultiLabel = (fieldList, keys) => {
      if (!keys) return "-";
      const keyArr = typeof keys === 'string' ? keys.split(',') : (Array.isArray(keys) ? keys : [keys]);
      return keyArr
        .map((key) => {
          const item = fieldList.find((i) => i.key == key);
          return item ? item.value : key;
        })
        .join(", ");
    };

    const previewImage = (url) => {
      if (url) {
        ImagePreview([url]);
      }
    };

    return {
      getLabel,
      getStudentNumLabel,
      getMultiLabel,
      previewImage,
      schoolTypeList,
      schoolAreaList,
      ruduiPiciList,
      sxdClassMList,
      sxdGhdPopList,
      sxdHdkList,
      sgwZhuRenList1,
      zzmmList02,
      eduList01,
      majorList,
      haveTuanJobMajorList,
      schoolMajorList,
      salaryList,
      jobTitleList,
      teachSubjectNumList,
      teachSubjectsList,
      daDuiFdyTpyeList,
      format,
    };
  },
};
</script>

<style scoped lang="less">
.form-detail {
  padding-bottom: 20px;
  :deep(.van-cell__title) {
    color: #646566;
    flex: 1;
  }
  :deep(.van-cell__value) {
    color: #323233;
    flex: 1;
    text-align: right;
  }
}
.reason {
  font-size: 0.397rem;
  line-height: 1.4;
  color: #fd3535;
  vertical-align: middle;
  margin: 0.4rem;
}
</style>
